import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import SummaryBookCard from '../../components/SummaryBookCard/SummaryBookCard';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import './SummaryBooks.css';

function SummaryBooks() {
    const [books, setBooks] = useState([]);
    const [filteredBooks, setFilteredBooks] = useState([]);
    const [visibleBooks, setVisibleBooks] = useState(10);
    const [user, setUser] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    
    // فیلترهای جدید
    const [selectedLevel, setSelectedLevel] = useState('');
    const [selectedGenre, setSelectedGenre] = useState('');
    const [genres, setGenres] = useState([]);

    const cefrLevels = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'];

    const getSummaryBooks = async () => {
        try {
            toast.loading("Loading Summary Books...");
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/summary-books`);
            toast.dismiss();
            toast.success("Books loaded successfully!");
            const booksData = response.data || [];
            setBooks(booksData);
            setFilteredBooks(booksData);
            
            // استخراج ژانرهای منحصر به فرد
            const allGenres = [];
            booksData.forEach(book => {
                if (book.categories && Array.isArray(book.categories)) {
                    book.categories.forEach(cat => {
                        if (!allGenres.includes(cat)) {
                            allGenres.push(cat);
                        }
                    });
                }
            });
            setGenres(allGenres.sort());
        } catch (err) {
            console.error(err);
            toast.error("Failed to load books");
            setBooks([]);
            setFilteredBooks([]);
        }
    };

    // اعمال فیلترها
    const applyFilters = () => {
        let filtered = [...books];
        
        // فیلتر بر اساس سطح
        if (selectedLevel) {
            filtered = filtered.filter(book => book.cefrLevel === selectedLevel);
        }
        
        // فیلتر بر اساس ژانر
        if (selectedGenre) {
            filtered = filtered.filter(book => 
                book.categories && book.categories.includes(selectedGenre)
            );
        }
        
        // فیلتر بر اساس جستجو
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            filtered = filtered.filter(book =>
                (book.title && book.title.toLowerCase().includes(term)) ||
                (book.author && book.author.toLowerCase().includes(term))
            );
        }
        
        setFilteredBooks(filtered);
        setVisibleBooks(10);
    };

    useEffect(() => {
        applyFilters();
    }, [selectedLevel, selectedGenre, searchTerm, books]);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleLevelChange = (e) => {
        setSelectedLevel(e.target.value);
    };

    const handleGenreChange = (e) => {
        setSelectedGenre(e.target.value);
    };

    const resetFilters = () => {
        setSelectedLevel('');
        setSelectedGenre('');
        setSearchTerm('');
    };

    const loadMore = () => {
        setVisibleBooks(visibleBooks + 10);
    };

    useEffect(() => {
        const storedUser = localStorage.getItem('currentUser');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
        getSummaryBooks();
    }, []);

    const displayBooks = filteredBooks || [];
    const hasMore = visibleBooks < displayBooks.length;

    return (
        <>
            <Navbar />
            <div className="summary-books-container">
                <div className="container mt-4">
                    <div className="search-field mt-5 pt-2">
                        <h3 className="text-center mb-3">Summary Books Library</h3>
                        
                        {/* فیلترها */}
                        <div className="filters-container">
                            {/* جستجو */}
                            <div className="filter-group">
                                <input
                                    type="text"
                                    className="form-control search-input"
                                    onChange={handleSearch}
                                    placeholder="Search by title or author..."
                                    value={searchTerm}
                                />
                            </div>
                            
                            {/* فیلتر سطح */}
                            <div className="filter-group">
                                <select className="form-select filter-select" value={selectedLevel} onChange={handleLevelChange}>
                                    <option value="">All Levels</option>
                                    {cefrLevels.map(level => (
                                        <option key={level} value={level}>{level}</option>
                                    ))}
                                </select>
                            </div>
                            
                            {/* فیلتر ژانر */}
                            <div className="filter-group">
                                <select className="form-select filter-select" value={selectedGenre} onChange={handleGenreChange}>
                                    <option value="">All Genres</option>
                                    {genres.map(genre => (
                                        <option key={genre} value={genre}>{genre}</option>
                                    ))}
                                </select>
                            </div>
                            
                            {/* دکمه ریست */}
                            <button className="btn-reset-filters" onClick={resetFilters}>
                                Reset Filters
                            </button>
                        </div>
                        
                        {/* دکمه Add New Book برای ادمین */}
                        {user && user.role === 'admin' && (
                            <div className="add-book-btn-container">
                                <Link to="/add-summary-book" className="btn btn-danger">Add New Summary Book</Link>
                            </div>
                        )}
                    </div>

                    {/* تعداد نتایج */}
                    <div className="results-count">
                        {displayBooks.length} book{displayBooks.length !== 1 ? 's' : ''} found
                    </div>

                    {/* لیست کتاب‌ها */}
                    <div className="books-list">
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                            {displayBooks.slice(0, visibleBooks).map((book) => (
                                <SummaryBookCard key={book._id} {...book} />
                            ))}
                            {displayBooks.length === 0 && (
                                <div className="text-center w-100 py-5">
                                    <h5>No summary books found</h5>
                                    <button className="btn btn-link" onClick={resetFilters}>Clear filters</button>
                                </div>
                            )}
                        </div>
                    </div>
                    
                    {hasMore && (
                        <div className="d-flex mt-4 justify-content-center">
                            <button className="btn-load-more" onClick={loadMore}>
                                Load More
                            </button>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
}

export default SummaryBooks;